import { Link, useNavigate } from 'react-router-dom';
import { QRCode, QRCodeCanvas, QRCodeSVG } from "qrcode.react";

import './ProfileQR.css';
import { LogoIcon } from '../../../assets/icons/icons';
import ProfileGoBackButton from '../ProfileGoBackButton/ProfileGoBackButton';
import { APP_INSTALL_URL, PROFILE_MAIN_LINK } from '../../../assets/utils/constants';
import { useEffect, useState } from 'react';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import mainAppApi from '../../../assets/api/MainAppApi';

function ProfileQR() {
  const [code, setCode] = useState(null)
  const [preloaders, setPreloaders] = useState({
    init: true,
  })
  const navigate = useNavigate()

  useEffect(() => {
    mainAppApi.getUserAccessCode()
      .then((res) => {
        console.log(res)
        setCode(res)
        setPreloaders(prevValue => ({
          ...prevValue,
          init: false
        }))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  function shareInvitation() {
    const SHARE_TEXT = `Discover the world of premium watches!

Join through this link: ${APP_INSTALL_URL}
Use my access code: ${code.code} to unlock special offers.

Timeless style is just a tap away.`
    if (navigator.share) {
      navigator.share({
        title: 'SanyWatches Invitation',
        text: SHARE_TEXT,
      }).catch((error) => {
        console.error('Sharing failed', error);
      });
    } else {
      // If Web Share API is not available, send to native app
      window.ReactNativeWebView?.postMessage(JSON.stringify({
        type: 'SHARE_INVITATION',
        payload: {
          text: SHARE_TEXT
        }
      }));
    }
  }
  return (
    <div className='profile-QR'>
      <div className='profile-QR__heading'>
        <ProfileGoBackButton
          onClick={() => {
            navigate(`/${PROFILE_MAIN_LINK}`)
          }}
        />
        <Link className='profile-QR__heading-logo-box' to={'/'} >
          <LogoIcon
            mainClassName={'profile-QR__heading-logo-img'}
            fillClassName={'profile-QR__heading-logo-img-fill'}
          />
        </Link>
      </div>
      {preloaders.init ?
        <div className='profile-QR__preloader'>
          <MiniPreloader />
        </div>
        :
        code ?
          <>
            <div className='profile-QR__code-box'>
              <QRCodeSVG
                value={APP_INSTALL_URL}
                className="profile-QR__svg"
                level="H"
              />
            </div>
            <p className='profile-QR__code-value'>{code.code}</p>
            <button type='button' className={`profile-QR__share-button ${Number(code.usages_left) <= 0 ? 'profile-QR__share-button_inactive' : ''}`} onClick={shareInvitation}>
              Share Invitation
            </button>
            <p className='profile-QR__share-hint'>You have only <span className='profile-QR__share-hint-value'>{code.usages_left}</span>&nbsp;invitations left for&nbsp;this&nbsp;month</p>
          </>
          : null

      }


    </div>
  );
}

export default ProfileQR